var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.cardComponent,{tag:"component",attrs:{"log":_vm.log}})
}
var staticRenderFns = []

export { render, staticRenderFns }